// extracted by mini-css-extract-plugin
export default {"icon":"SwitchIndicator-icon_SiM6V"};